import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-6201e778"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "app-main"
};
import { watch, onMounted, onUnmounted } from 'vue';
import { isTags } from '@/utils/tags';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';
export default {
  __name: 'AppMain',
  setup(__props) {
    const route = useRoute();

    /**
     * 生成 title
     */
    const getTitle = route => {
      let title = '';
      if (!route.meta) {
        // 处理无 meta 的路由W
        const pathArr = route.path.split('/');
        title = pathArr[pathArr.length - 1];
      } else {
        title = route.meta.title;
      }
      return title;
    };

    /**
     * 监听路由变化
     */
    const store = useStore();
    watch(route, (to, from) => {
      if (!isTags(to.path)) return;
      const {
        fullPath,
        meta,
        name,
        params,
        path,
        query
      } = to;
      store.commit('app/addTagsViewList', {
        fullPath,
        meta,
        name,
        params,
        path,
        query,
        title: getTitle(to)
      });
    }, {
      immediate: true
    });
    const refreshUserInfo = () => {
      console.log('用户刷新界面');
    };
    onMounted(() => {
      document.addEventListener('beforeunload', refreshUserInfo);
    });
    onUnmounted(() => {
      document.removeEventListener('beforeunload', refreshUserInfo);
    });
    return (_ctx, _cache) => {
      const _component_router_view = _resolveComponent("router-view");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_router_view, null, {
        default: _withCtx(({
          Component,
          route
        }) => [_createVNode(_Transition, {
          name: "fade-transform",
          mode: "out-in"
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_KeepAlive, null, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
            key: route.path
          }))], 1024))]),
          _: 2
        }, 1024)]),
        _: 1
      })]);
    };
  }
};